export { GDPRBanner, default } from "./GDPRBanner";
export { CookieSettingsButton } from "./CookieSettingsButton";
